import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useMatchMedia(media) {
  const $ = _c(9);
  const [mediaQueryList, setMediaQueryList] = useState(_temp);
  const [mediaMatches, setMediaMatches] = useState(mediaQueryList.matches);
  let t0;
  if ($[0] !== media || $[1] !== mediaQueryList.media) {
    t0 = () => {
      if (media !== mediaQueryList.media) {
        setMediaQueryList(window.matchMedia(media));
      }
    };
    $[0] = media;
    $[1] = mediaQueryList.media;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== media || $[4] !== mediaQueryList) {
    t1 = [media, setMediaQueryList, mediaQueryList];
    $[3] = media;
    $[4] = mediaQueryList;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[6] !== mediaQueryList) {
    t2 = () => {
      const updateQueryMatches = () => {
        setMediaMatches(mediaQueryList.matches);
      };
      mediaQueryList.addEventListener("change", updateQueryMatches);
      updateQueryMatches();
      return () => {
        mediaQueryList.removeEventListener("change", updateQueryMatches);
      };
    };
    t3 = [setMediaMatches, mediaQueryList];
    $[6] = mediaQueryList;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  return mediaMatches;
}
function _temp() {
  return window.matchMedia("query");
}